import { Link } from 'react-router-dom';
import { ORACLE_FACTS, ORACLE_LIFECYCLE } from '@/lib/site';
import { formatDate } from '@/lib/format';

// The 12c → 14c strip. Verified facts only (CONTENT-SPEC §3.9). When Oracle
// revises a date, change ORACLE_FACTS in src/lib/site.ts — not this file.
const MILESTONES = [
  {
    when: '2025',
    what: `14c (${ORACLE_FACTS.release14c}) releases available`,
    detail: `WebCenter, SOA Suite, WebLogic, BPM, ADF and ODI ship ${ORACLE_FACTS.release14c}. Oracle Forms 14c is ${ORACLE_FACTS.forms14c}; Identity and Access Management 14c is ${ORACLE_FACTS.iam14c}.`,
  },
  {
    when: ORACLE_FACTS.fmw12cPremierEnds,
    what: 'Premier Support for applicable 12.2.x products ends',
    detail: 'Use the exact product, release and policy footnotes to confirm the window for your estate.',
  },
  {
    when: ORACLE_FACTS.fmw12cExtendedEnds,
    what: 'Extended Support for applicable 12.2.x products ends',
    detail: 'Confirm eligibility and terms with Oracle. Any separately contracted support requires its own scope and commercial confirmation.',
  },
];

const Timeline = ({ compact = false }: { compact?: boolean }) => (
  <section aria-labelledby="timeline-heading" className="border-y border-rule bg-cream-light">
    <div className={`container ${compact ? 'py-10' : 'py-14 md:py-16'}`}>
      <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
        <h2 id="timeline-heading" className="text-subhead">
          The 12c → 14c program, on one line
        </h2>
        <Link to="/upgrades" className="link inline-flex min-h-11 items-center text-small">
          See every component's 14c path
        </Link>
      </div>
      <ol className="mt-8 grid gap-8 border-t-2 border-forest pt-6 md:grid-cols-3 md:gap-10">
        {MILESTONES.map((m) => (
          <li key={m.what} className="relative pl-5 md:pl-0">
            <span aria-hidden className="absolute -left-px top-1 h-3 w-3 bg-forest md:-top-[31px] md:left-0" />
            <p className="label">{m.when}</p>
            <p className="mt-2 text-[1.375rem] font-bold leading-[1.25]">{m.what}</p>
            {!compact && <p className="mt-2 text-body">{m.detail}</p>}
          </li>
        ))}
      </ol>
      <p className="mt-8 text-small text-forest/80">
        Source: <a className="link" href={ORACLE_LIFECYCLE.source}>Oracle Lifetime Support Policy</a>, effective{' '}
        {formatDate(ORACLE_LIFECYCLE.policyEffective)}; checked {formatDate(ORACLE_LIFECYCLE.checked)}.
        {' '}Exact product and error-correction terms apply.
      </p>
    </div>
  </section>
);

export default Timeline;
